module.exports = __webpack_public_path__ + "static/media/app-store-qr-code.bf5b0997.svg";